import React, {createContext, useContext, useState} from 'react';
import {ThemeProvider as MuiThemeProvider} from '@mui/material/styles';
import {observer} from 'mobx-react';
import {ThemeStorage} from './ThemeStorage';
import {LocalStorage} from "../LocalStorage";
import darkTheme from "./darkTheme";
import lightTheme from "./lightTheme";

const ThemeContext = createContext();

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};

const SaporeThemeProvider = observer(({ children }) => {
    const [themeStorage] = useState(() => new ThemeStorage(new LocalStorage()));
    const [currentThemeName, setCurrentThemeName] = useState(() => themeStorage.getCurrentTheme());

    const themes = {
        dark: darkTheme,
        light: lightTheme
    };

    const currentTheme = themes[currentThemeName] || themes.dark;

    const toggleTheme = () => {
        const newTheme = themeStorage.toggleTheme();
        setCurrentThemeName(newTheme);
    };

    const setTheme = (themeName) => {
        if (themes[themeName]) {
            themeStorage.setTheme(themeName);
            setCurrentThemeName(themeName);
        }
    };

    const themeContextValue = {
        currentTheme: currentThemeName,
        toggleTheme,
        setTheme,
        isDarkTheme: () => currentThemeName === 'dark',
        isLightTheme: () => currentThemeName === 'light'
    };

    return (
        <ThemeContext.Provider value={themeContextValue}>
            <MuiThemeProvider theme={currentTheme}>
                {children}
            </MuiThemeProvider>
        </ThemeContext.Provider>
    );
});

export default SaporeThemeProvider;
